import { render, staticRenderFns } from "./CharacterBuilderClassHitPoints.vue?vue&type=template&id=6e4da8c0&lang=pug&"
import script from "./CharacterBuilderClassHitPoints.vue?vue&type=script&lang=ts&"
export * from "./CharacterBuilderClassHitPoints.vue?vue&type=script&lang=ts&"
import style0 from "./CharacterBuilderClassHitPoints.vue?vue&type=style&index=0&module=true&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports